import { PatientDocumentType } from 'types.d';

export const MAX_DOCUMENT_BYTES = 20 * 1024 * 1024;

export const ACCEPTED_EXTENSIONS = [
  '.pdf',
  '.jpg',
  '.jpeg',
  '.png',
  '.doc',
  '.docx',
];

export const DOCUMENT_TYPE_LABEL: Record<PatientDocumentType, string> = {
  [PatientDocumentType.Prescription]: 'Prescription',
  [PatientDocumentType.DoctorNote]: "Doctor's note",
  [PatientDocumentType.Other]: 'Other',
};

export const formatSize = (bytes: number) => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};
